import { ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM } from '../../../../../config/constants';
import { config as wsTitleConfig } from './title/wsTitleConfig';
import { config as wsVariantPickerConfig } from './variantPicker/wsVariantPickerConfig';
import { config as wsBuyButtonsConfig } from './buyButtons/wsBuyButtonsConfig';
import { config as wsPriceConfig } from './price/wsPriceConfig';
import { config as wsQuantitySelectorConfig } from './quantitySelector/wsQuantitySelectorConfig';
import { config as wsDescriptionConfig } from './description/wsDescriptionConfig';
import { config as wsInventoryStatusConfig } from './inventoryStatus/wsInventoryStatusConfig';

const ECOM_WEBSTORE_SECTION_BLOCKS = {
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.TITLE]: wsTitleConfig,
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.PRICE]: wsPriceConfig,
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.VARIANT_PICKER]: wsVariantPickerConfig,
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.QUANTITY_SELECTOR]: wsQuantitySelectorConfig,
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.BUY_BUTTONS]: wsBuyButtonsConfig,
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.DESCRIPTION]: wsDescriptionConfig,
  [ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.INVENTORY_STATUS]: wsInventoryStatusConfig
};

const ECOM_WEBSTORE_SECTION_BLOCK_LIST = Object.keys(
  ECOM_WEBSTORE_SECTION_BLOCKS
).reduce((r, c) => [...r, ECOM_WEBSTORE_SECTION_BLOCKS[c]], []);

export { ECOM_WEBSTORE_SECTION_BLOCKS, ECOM_WEBSTORE_SECTION_BLOCK_LIST };
